import React from "react";
import "./ForInfluencersPart.scss";

import Cat from "assets/images/forInfluencers/cat.png"
import Hand from "assets/images/forInfluencers/hand.svg";
import {LightningBanner} from "./components/LightningBanner";
import {BannerTrapezoid} from "./components/BannerTrapezoid";
import { Button } from "shared/components/Button";
import {RouteUrls} from "routing/routing.constants";
import {PageType} from "shared/constants/PageType";
import {useConfigCenter} from "core/context/ConfigCenter";
import {LightningBannerMobile} from "./components/LightningBannerMobile";

export const ForInfluencersPart: React.FC = () => {
    const [, {changePage}] = useConfigCenter();
    return (
        <div className="influencers">
            <div className="influencers__title">
                FOR INFLUENCERS:
            </div>
            <img src={Cat} className="cat" alt='cat'/>
            <img src={Hand} className="hand" alt="hand"/>
            <LightningBanner className="lightning-banner"/>
            <LightningBannerMobile className="lightning-banner-mobile"/>
            <BannerTrapezoid className="banner-trapezoid"/>
            <div className="influencers__btn">
                <Button to={`${RouteUrls.FOR_INFLUENCERS_URL}/`} onClick={(event) => changePage(PageType.FOR_INFLUENCERS, undefined, event)}>
                    GRAB EXCLUSIVE ACCESS
                </Button>
            </div>
        </div>
    )
}
